import React, { useState } from 'react';
import { Player } from '@lottiefiles/react-lottie-player';
import './FanfareConfetti.css';

const LOTTIE_URL = `${process.env.PUBLIC_URL || ''}/Confeti.json`;

function FanfareConfetti() {
  const [visible, setVisible] = useState(true);

  const handleComplete = () => {
    setVisible(false);
  };

  return (
    <div
      className="fanfare-confetti fanfare-confetti-lottie"
      aria-hidden="true"
      style={{ opacity: visible ? 1 : 0, pointerEvents: visible ? 'none' : 'none' }}
    >
      <Player
        autoplay
        loop={false}
        src={LOTTIE_URL}
        className="fanfare-lottie-player"
        onEvent={(e) => {
          if (e === 'complete') handleComplete();
        }}
      />
    </div>
  );
}

export default FanfareConfetti;
